import React from 'react';
import classnames from 'classnames';

import callApi from '../../utils/callApi';
import {
  CHECK_PROMOTION_AVAILABLE_FOR_USER,
  FETCH_GENERATED_USERNAME,
  LIST_EPAY_NAKEDNEWS_FANCLUB,
  LIST_EPAY_PACKAGES,
  LIST_ALL_EPAY_PRICES_FANCLUB,
  TEMPTED_SUBSCRIPTION_PRICE_FOR_ANCHOR,
  STATUS_URL,
} from '../../constants/apiUrls/apiUrls';
import { EXPIRED_PROMOS, PROMO_CODES } from '../../constants/promoCodes';
import MaintainenceImage from '../../assets/maintainence.jpg';
import nnliveImage2 from '../../assets/createAccountPage/nn-banner-checkout-left.png';
import AccountPackages from '../../components/accountComponents/AccountPackages';
import { getCookie } from '../../utils/helpers';
import taglineLogo from '../../assets/createAccountPage/nn_taglinelogo_hd-7261aedcdab6423445387624801ca3e6.png';
import getAccess from '../../assets/createAccountPage/get_access-fb181c83daf3ff922d2a54508ca391d8.png';
import CountdownTimerComponent
  from '../../components/generalComponents/CountdownTimerComponent/CountdownTimerComponent';
import { returnCorrectProduct, returnFirstLowerProduct } from '../../utils/PriceValidator';

import { getAnchorImage, getRandomImage } from './createAccountImages';

import './css/CreateAccount.css';
import IsabellaPaymentImage from '../../assets/createAccountPage/Alana-main-payment.png';
import MarinaPaymentImage from '../../assets/createAccountPage/marina-main-payment.png';
import CampaignAnchor1 from '../../assets/CampaignAssets/eila.png';
import CampaignAnchor2 from '../../assets/CampaignAssets/alana.png';
import CampaignBackground from '../../assets/CampaignAssets/July-4th-subscription-background.jpg';


class CreateAccountPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      programs: [],
      anchorSubscriptionPrograms: [],
      isLoading: true,
      createdUser: '',
      token: '',
      showPromoInput: false,
      feeIsAdded: false,
      promoInUrl: {},
      isCampaignActive: false,
    };

    const urlParams = new URLSearchParams(window.location.search);
    this.anchorToSubscribe = urlParams.get('_anchor');
    this.disableOneClickPaysafe = urlParams.get('_disableOneClickPaysafe');
    this.amountParam = urlParams.get('_amount');
    this.shortUrlParam = urlParams.get('_shortUrl');
    this.code = urlParams.get('code');
    this.promoCode = urlParams.get('promoCode')?.toUpperCase();

    // enable in case of Paysafe problems
    // this.paymentWhitelisted = user && user.features && user.features.includes('ENABLE_PAYMENT');
    this.paymentWhitelisted = true;

    this.createAccountImage = this.anchorToSubscribe ? getAnchorImage(this.anchorToSubscribe) : getRandomImage();
  }

  fetchPackages = (promoCode, pcode) => {
    const { user, activeCampaign, isAccountCreationPage } = this.props;
    const promoPage = (
      window.location.pathname === '/lifetime-promo-live' ||
      window.location.pathname === '/promo/asn-awards'
    );
    const NNLivePromoPage = window.location.pathname === '/nnl-promo-card';
    const NNPromoPage = window.location.pathname === '/nn-promo-card';
    const data = {};
    const mrSkinCampaign = activeCampaign.affiliateCode === PROMO_CODES.NNLIVEMRSK4;
    const isMembershipCheckout = this.isMembershipCheckoutPage();
    const isCampaignActive = mrSkinCampaign ||
      (activeCampaign.affiliateCode &&
        isMembershipCheckout);
    this.setState({ isCampaignActive });

    if (isAccountCreationPage) {
      this.setState({ showPromoInput: true });
    }

    if (user.authenticated) {
      const { username } = user.user;
      data.token = sessionStorage.getItem('token');
      data.userName = username;
    }


    if (isCampaignActive) {
      data.affiliateCode = activeCampaign.affiliateCode;
      data.pcode = activeCampaign.affiliateCode;
    }

    if (isAccountCreationPage && !isCampaignActive) {
      delete data.affiliateCode;
      delete data.pcode;
    }

    if ((activeCampaign.affiliateCode && !mrSkinCampaign) || (mrSkinCampaign && promoPage)) {
      data.affiliateCode = activeCampaign.affiliateCode;
      data.pcode = activeCampaign.pcode;
    }

    if (NNLivePromoPage) {
      delete data.affiliateCode;
      data.pcode = 'nnlpromo20220505';
    }

    if (NNPromoPage) {
      delete data.affiliateCode;
      data.pcode = 'nnpromo20220505';
    }

    if (promoCode && pcode && isAccountCreationPage) {
      data.affiliateCode = promoCode;
      data.pcode = pcode;
    }

    if (this.promoCode?.length) {
      data.affiliateCode = this.promoCode;
      data.pcode = this.promoCode;
    }

    const affiliateCode = getCookie('_atc');
    if (affiliateCode && !EXPIRED_PROMOS.includes(affiliateCode) && affiliateCode === PROMO_CODES.CAM4_SOURCE) {
      data.affiliateCode = affiliateCode;
      delete data.pcode;
    }
    if (affiliateCode === PROMO_CODES.CAM4_SOURCE && !user.authenticated) {
      this.fetchUserName().
        then((usernameRes) => {
          const { username } = usernameRes.data;
          this.setState({ createdUser: username });
          data.userName = username;
          callApi(STATUS_URL, 'get', {}, {}, {}, true, true).
            then((res) => {
              if (res.data.user) {
                const { token } = res.data.user;
                this.setState({ token });
                data.token = token;
              } else {
                document.cookie = `_atc=${PROMO_CODES.CAM4_SOURCE}; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`;
                window.location = '/account/purchase';
              }

              callApi(LIST_EPAY_PACKAGES, 'get', data, {}, {}, false).
                then((res) => {
                  this.setState({
                    programs: res.data.products,
                    isLoading: false,
                  });
                }).
                catch((e) => console.error(e));
            }).
            catch((e) => console.error(e));
        }).
        catch((e) => console.error(e));
    } else {
      if (user.authenticated) {
        const { token } = user.user;
        data.token = token;
      }
      const url = NNLivePromoPage ? LIST_EPAY_NAKEDNEWS_FANCLUB : LIST_EPAY_PACKAGES;
      callApi(url, 'get', data, {}, {}, false).
        then((res) => {
          if (res.data.reason) {
            this.redirectToHome();

            return;
          }
          let allProducts = res.data.products;
          if (res.data.products[0].details?.fee > 0) {
            this.setState({ feeIsAdded: true });
          }
          if (activeCampaign.affiliateCode === PROMO_CODES.NNLIVEMRSK4) {
            allProducts = allProducts.slice(0, 1);
          }
          this.setState({
            programs: allProducts,
            isLoading: false,
          });
        }).
        catch((e) => console.error(e));
    }

  };

  fetchUserName = () => callApi(
    FETCH_GENERATED_USERNAME,
    'post',
    {},
    {},
    { 'content-type': 'application/json; charset=utf-8' },
    false
  );

  checkIfUserHasPromotion = (hashCode) => {
    const URL = CHECK_PROMOTION_AVAILABLE_FOR_USER.replace('{hashCode}', hashCode);

    return callApi(URL, 'GET');
  };

  checkIfProductExists = (filteredProductsArray, allProducts) => {
    if (!filteredProductsArray.length || !filteredProductsArray?.[0]) {
      return allProducts?.data?.products.slice(0, 1);
    }

    return filteredProductsArray;
  };

  fetchAnchorSubscriptionPackages = async (promoCode, pcode) => {
    const { user, anchorPortalCampaign, activeCampaign } = this.props;
    const atc = getCookie('_atc');
    const data = {};
    const params = new URLSearchParams(window.location.search);
    const hashCode = params.get('code');
    const isFanzoneCheckout = this.shortUrlParam !== '';

    if (isFanzoneCheckout) {
      this.setState({ showPromoInput: true });
    }

    if (hashCode) {
      try {
        const res = await this.checkIfUserHasPromotion(hashCode);
        if (res.status === 200 && res.data === 'OK') {
          const codeForEPay = PROMO_CODES.TRIALFANCLUBS.toLocaleLowerCase();
          data.affiliateCode = codeForEPay;
          data.pcode = codeForEPay;
          this.setState({ promoInUrl: { affiliateCode: data.affiliateCode, pcode: data.pcode, hash: hashCode } });
        }
      } catch {
        console.error('No Promotion available');
      }
    }

    if (hashCode === '2022-cyber-monday-promo' && activeCampaign?.affiliateCode === 'CYBERMONDAY2022') {
      data.affiliateCode = 'CYBERMONDAY2022';
      data.pcode = 'CYBERMONDAY2022';
      this.setState({ promoInUrl: { affiliateCode: data.affiliateCode, pcode: data.pcode } });
    }

    if (user.authenticated) {
      data.token = sessionStorage.getItem('token');
      data.userName = user.user.username;
    }

    if (promoCode && pcode) {
      data.affiliateCode = promoCode;
      data.pcode = pcode;
    }

    if (this.promoCode?.length) {
      data.affiliateCode = this.promoCode;
      data.pcode = this.promoCode;
    }

    if (
      (atc === PROMO_CODES.CAM4_ANCHOR_SOURCE || atc === PROMO_CODES.PROMO_ANCHOR_SOURCE) &&
      anchorPortalCampaign.anchorPortal &&
      anchorPortalCampaign.pcode
    ) {
      data.pcode = anchorPortalCampaign.pcode;
    }

    const epayPricesURL = LIST_ALL_EPAY_PRICES_FANCLUB;
    const temptedSubscriptionPriceURL = TEMPTED_SUBSCRIPTION_PRICE_FOR_ANCHOR.replace('{anchorId}', encodeURIComponent(this.anchorToSubscribe));

    callApi(epayPricesURL, 'get', data, {}, {}, false).
      then((pricesRes) => {
        if (pricesRes.data.reason) {
          this.redirectToHome();

          return;
        }

        callApi(temptedSubscriptionPriceURL, 'get').
          then((res) => {
            const { data } = res;
            const productInfo = returnCorrectProduct(pricesRes, data.price);
            let anchorSubProduct = this.checkIfProductExists(productInfo?.priceInfo, pricesRes);

            if (promoCode) {
              anchorSubProduct = pricesRes.data.products.filter((product) => !product.details.max);
            }
            if (promoCode === 'ASN23FANZONE') {
              let product = returnCorrectProduct(pricesRes, data.price);
              if (!product?.priceInfo?.length) {
                product = returnFirstLowerProduct(pricesRes, data.price);
              }
              anchorSubProduct = this.checkIfProductExists(product?.priceInfo, pricesRes);
            }

            this.setState({
              anchorSubscriptionPrograms: anchorSubProduct,
              isLoading: false,
              feeIsAdded: productInfo.fee,
            });
          });
      }).
      catch((e) => console.error(e));
  };

  redirectToHome() {
    window.location.href = '/';
  }

  componentDidMount() {
    if (this.anchorToSubscribe) {
      this.paymentWhitelisted && this.fetchAnchorSubscriptionPackages();
    } else {
      this.paymentWhitelisted && this.fetchPackages();
    }

    if (document.getElementById('navigation')) {
      document.getElementById('navigation').style.display = 'none';
    }
    if (document.getElementsByClassName('footer').length) {
      document.getElementsByClassName('footer')[0].style.display = 'none';
    }
  }

  componentWillUnmount() {
    document.getElementById('navigation').style.display = '';
  }

  displayUnavailableMessage() {
    return (
      <div className="unavailable-container" style={{ width: '100%', height: '100vh' }}>
        <div className="container" style={{ height: '100%' }}>
          <div className="unavailable-message">
            <img
              alt="maintainence" src={MaintainenceImage} style={{
                width: '100%',
                maxWidth: '420px',
                margin: '0 0 30px',
                border: '0',
              }}
            />
            <h3>Sorry! Account creation is unavailable for the moment.</h3>
            <p style={{ fontSize: '20px' }}>We are working to get it working as soon as possible!</p>
            <button
              className="btn btn-primary caps montserrat package-button"
              style={{ marginTop: '20px' }}
              onClick={this.redirectToHome}
            >
              Return
            </button>
          </div>
        </div>
      </div>
    );
  }

  needToBeInvisible = () => [
    '/promo/asn-awards',
    '/lifetime-promo-live',
    '/account/purchase',
    // new pages that we would like to have invisible
  ].includes(window.location.pathname + window.location.search);

  isMembershipCheckoutPage = () => {
    return window.location.pathname.includes('/account/purchase') && !this.anchorToSubscribe;
  }

  decideBackgroundImage = (isCampaignActive, checkoutImage, isMrSkinCampaign) => {
    if (isCampaignActive && !isMrSkinCampaign) {
      return `url(${CampaignBackground})`;
    }

    if (isCampaignActive) {
      return `url(${checkoutImage})`;
    }

    return '';
  }

  render() {
    const currentYear = new Date().getFullYear();
    const { user, activeCampaign, anchorPortalCampaign, listOfActiveCampaigns } = this.props;
    const { programs, isLoading, anchorSubscriptionPrograms, showPromoInput, feeIsAdded, promoInUrl, isCampaignActive } = this.state;
    const promoPage = (
      window.location.pathname === '/lifetime-promo-live' ||
      window.location.pathname === '/promo/asn-awards'
    );
    const { affiliateCode, checkoutImage } = activeCampaign || {};
    const NNLivePromoPage = window.location.pathname === '/nnl-promo-card';
    const NNPromoPage = window.location.pathname === '/nn-promo-card';
    const ASNMagazineCampaign = window.location.pathname === '/promo/asn-awards';
    const isNNLIVEMRSK4 = promoPage && affiliateCode === PROMO_CODES.NNLIVEMRSK4;
    const isASNAW22 = ASNMagazineCampaign && affiliateCode === PROMO_CODES.ASNAW22;

    let anchorAccountImage = this.createAccountImage.anchorImage;
    if (isNNLIVEMRSK4 || isASNAW22) {
      anchorAccountImage = nnliveImage2;
    }

    if (!this.paymentWhitelisted) {
      return this.displayUnavailableMessage();
    }

    const isMembershipPaymentPage = this.isMembershipCheckoutPage();
    const isInvisible = this.needToBeInvisible() || isCampaignActive || isMembershipPaymentPage;
    const backgroundImage = this.decideBackgroundImage(isCampaignActive, checkoutImage, isNNLIVEMRSK4);
    let anchorLeftImage = isMembershipPaymentPage ? MarinaPaymentImage : anchorAccountImage;
    anchorLeftImage = isCampaignActive && !isNNLIVEMRSK4 ? CampaignAnchor1 : anchorLeftImage;
    const anchorRightImage = isCampaignActive ? CampaignAnchor2 : IsabellaPaymentImage;

    return (
      <div
        className="create-account-container"
        id={classnames({ 'ASNMagazineCampaign': ASNMagazineCampaign })}
      >
        <div id="navigation2">
          <nav
            className="navbar navbar-lg navbar-topnav navbar-static-top"
            id="header-nav"
            role="navigation"
          >
            <div className="container">
              <span className="navbar-brand">
                <a href="/">
                  <img
                    alt="Naked News: The Program With Nothing To Hide"
                    src={taglineLogo}
                    style={{ width: '100%' }}
                  />
                </a>
              </span>
              <span className="pull-right visible-md visible-lg">
                <img
                  alt="Get access"
                  src={getAccess}
                  style={{ padding: '29px 0' }}
                />
              </span>
              {!this.anchorToSubscribe && activeCampaign && activeCampaign.hasTimer && activeCampaign.secondsLeft &&
                <div className="pull-right timerArea">
                  <CountdownTimerComponent activeCampaign={activeCampaign} />
                </div>
              }
            </div>
          </nav>
        </div>
        <div
          className={classnames(
            'purchaseIndexViewWrapper', {
            'mr-skin-promo': isNNLIVEMRSK4,
            'membership-checkout': isMembershipPaymentPage,
            'force-background-color': isCampaignActive,
          })}
          id="purchaseIndexViewContainer"
          style={{ backgroundImage }}
        >
          {!isLoading &&
            <div id="purchaseIndexView">
              <div
                className={classnames({
                  'content': true,
                  'package-invisible': isInvisible,
                })}
              >
                <div className="container">
                  <div className="row-r" id="join_header">
                    {
                      this.anchorToSubscribe ? (
                        <>
                          <div className="col-md-6 col-sm-12 col-xs-12">
                            <AccountPackages
                              activeCampaign={{}}
                              amountParam={this.amountParam}
                              anchorPortalCampaign={anchorPortalCampaign}
                              anchorShortUrl={this.shortUrlParam}
                              anchorSubscriptionPrograms={anchorSubscriptionPrograms}
                              anchorToSubscribe={this.anchorToSubscribe}
                              disableOneClickPaysafe={this.disableOneClickPaysafe}
                              feeIsAdded={feeIsAdded}
                              fetchPackages={this.fetchAnchorSubscriptionPackages}
                              hasPromoInURL={promoInUrl}
                              isInvisible={isInvisible}
                              isCampaignActive={isCampaignActive}
                              listOfActiveCampaigns={listOfActiveCampaigns}
                              showPromoInput={showPromoInput}
                              user={user}
                            />
                          </div>
                          <div
                            className="col-md-6 col-sm-12 col-xs-12 accounts-right-image"
                            style={{ textAlign: 'right' }}
                          >
                            <img alt="" src={this.createAccountImage.anchorImage} />
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className={classnames(
                              'col-sm-12',
                              'col-xs-12',
                              'accounts-right-image',
                              {
                                'col-md-6': !isMembershipPaymentPage,
                                'col-md-3': isMembershipPaymentPage,
                              })}
                            style={{ textAlign: 'right' }}
                          >
                            <img alt="" src={anchorLeftImage} />
                          </div>
                          <div
                            className={classnames(
                              'col-sm-12',
                              'col-xs-12',
                              'account-left-section',
                              {
                                'col-md-6': !isMembershipPaymentPage,
                                'col-md-3': isMembershipPaymentPage,
                              })}
                          >
                            <AccountPackages
                              NNLivePromoPage={NNLivePromoPage}
                              NNPromoPage={NNPromoPage}
                              activeCampaign={activeCampaign}
                              amountParam={this.amountParam}
                              createdUser={this.state.createdUser}
                              disableOneClickPaysafe={this.disableOneClickPaysafe}
                              feeIsAdded={feeIsAdded}
                              fetchPackages={this.fetchPackages}
                              isInvisible={isInvisible}
                              isMembershipPaymentPage={isMembershipPaymentPage}
                              isCampaignActive={isCampaignActive}
                              listOfActiveCampaigns={listOfActiveCampaigns}
                              programs={programs}
                              showPromoInput={showPromoInput}
                              token={this.state.token}
                              user={user}
                            />
                          </div>
                          <div
                            className={classnames(
                              'col-sm-12',
                              'col-xs-12',
                              'accounts-right-image',
                              'image-right',
                              {
                                'col-md-6': !isMembershipPaymentPage,
                                'col-md-3': isMembershipPaymentPage,
                                'hide': !isMembershipPaymentPage,
                              })}
                            style={{ textAlign: 'right' }}
                          >
                            <img alt="" src={anchorRightImage} />
                          </div>
                        </>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <div
          className="footer2" style={{
            backgroundColor: '#000',
            paddingTop: '20px',
          }}
        >
          <div className="container">
            <p
              className="text-center" style={{
                fontSize: '12px',
                color: '#fff',
              }}
            >
              Copyright © 1999-{currentYear} Naked Broadcasting Network
              Inc. All Rights Reserved.
              <a href="/terms_of_service" style={{ color: '#fff' }}>Terms of Use</a>
              <br />
              "Naked News" is a registered trademark of Egalaxy
              Multimedia Inc.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateAccountPage;
